import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";

import LotForm from "components/agro/lots/LotForm";
import { createLot } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const LotCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const lot = {
    farmID: "",
    lotNumber: "",
    name: "",
    sizeM2: "",
    perimeterM: "",
    location: "",
    status: "",
    cropTypeId: "",
    cropUnits: "",
    performedById: "",
    quantity: "",
    photoEvidence: "",
    blueprints: "",
    description: "",
    companyID: me?.companyID ?? "",
  };

  async function onSubmit(valuesParam) {
    try {
      const {
        farmID,
        lotNumber,
        name,
        sizeM2,
        perimeterM,
        location,
        status,
        cropTypeId,
        cropUnits,
        performedById,
        quantity,
        photoEvidence,
        blueprints,
        description,
        companyID,
      } = valuesParam;

      await API.graphql({
        query: createLot.replaceAll("__typename", ""),
        variables: {
          input: {
            farmID,
            lotNumber:
              lotNumber === undefined || lotNumber === ""
                ? null
                : Number(lotNumber),
            name,
            sizeM2:
              sizeM2 === undefined || sizeM2 === "" ? null : Number(sizeM2),
            perimeterM:
              perimeterM === undefined || perimeterM === ""
                ? null
                : Number(perimeterM),
            location,
            status,
            cropTypeId,
            cropUnits,
            performedById,
            quantity:
              quantity === undefined || quantity === ""
                ? null
                : Number(quantity),
            photoEvidence,
            blueprints,
            description,
            companyID,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/agro/lots");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <LotForm onSubmit={onSubmit} initialValues={lot} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Lote",
    successAdded: "Lote agregado con éxito",
    responses: {},
  },
});

export default LotCreateForm;
